import type { ValueFormat } from "../data/types";

export function fmtNumber(n: number): string {
  return Math.round(n).toLocaleString("en-IN");
}

export function fmtCurrency(n: number): string {
  if (n >= 10000000) return `₹${(n / 10000000).toFixed(1)}Cr`;
  if (n >= 100000) return `₹${(n / 100000).toFixed(1)}L`;
  if (n >= 1000) return `₹${(n / 1000).toFixed(1)}k`;
  return `₹${Math.round(n)}`;
}

export function fmtPercent(n: number): string {
  return `${n.toFixed(1)}%`;
}

export function fmtValue(n: number, format: ValueFormat): string {
  if (format === "currency") return fmtCurrency(n);
  if (format === "percent") return fmtPercent(n);
  return fmtNumber(n);
}

/** "+12.5%" / "-3.2%" */
export function fmtDeltaPct(n: number): string {
  return `${n >= 0 ? "+" : ""}${n.toFixed(1)}%`;
}
